import * as _ from "lodash";
import beneficiaryAgreementTemplate from "./beneficiaryAgreement/beneficiaryAgreementTemplate";
import beneficiaryBcomErrors from "../../../../common/constants/beneficiaryBcomErrors";

/**
 * This is a separate controller for the list view that allows us to isolate
 * the list logic from other views.
 *
 * @param $scope
 * @param $injector
 */
var BeneficiaryListController = function (
    $scope,
    $modal,
    beneficiaryService,
    dataService,
    participantService,
    allocationFactory,
    $state,
    $stateParams,
    $translate
) {
    // ViewModel replaces $scope
    var vm = this;

    if ($state.last && $state.last.name == "accountDetails.beneficiaries.confirmBeneficiaries") {
        $state.reload();
    }

    var planFormsLink =
        "/participant/accounts/#/account/" +
        $stateParams.individualId +
        "/" +
        $stateParams.groupId +
        "/plan-forms";
    // Translation Strings
    vm.translate = {
        benePageUpdate: {
            linkBegin: "<a target=“_blank”>",
            linkEnd: "</a>"
        },
        nonSpousalBeneficiaryFormLink: {
            allocationPercent: "100",
            linkBegin: '<a ng-click="trackSpousalConsentDownload()" href="' + planFormsLink + '">',
            linkEnd: "</a>"
        }
    };

    //Errors returned from BCOM that are displayed on the web
    vm.beneficiaryBcomErrors = beneficiaryBcomErrors;

    // Error messages for Primary
    vm.errosAll = [];
    vm.errorsPrimary = [];
    vm.errorsContigent = [];
    vm.loading = false;
    vm.accessDetermined = beneficiaryService.getBeneAccessParams().beneRAccess !== null;

    //Allocation Errors from backend that span across benes on a save beneficiaries call
    //there should only be 1
    vm.allocationErrorAcrossAllBenes = "";
    vm.errorAcrossAllBenes = [];
    //Errors returned from the save beneficiaries call that we do not recognize
    vm.unknownErrors = "";

    /**
     * Triggered when the allocation for a beneficiary is changed. We need to
     * execute the validation so any error messages disappear as soon as the
     * participant fixes the issue.
     */
    vm.allocationChanged = function () {
        $scope.data.dataChanged = true;
        $scope.data.autoAllocations = false;
        vm.checkAllocations();
    };

    vm.checkAllocations = function () {
        vm.errosAll = allocationFactory.validateAllocations(
            $scope.data.beneficiaries,
            $scope.data.maritalStatus
        );
        vm.errorsPrimary = vm.errosAll[0];
        vm.errorsContigent = vm.errosAll[1];
        vm.shouldSubmitButtonBeDisabled();
    };

    vm.listAutoCheck = function () {
        $scope.$watch(
            function () {
                return $scope.data.startUpcheck;
            },
            function (newValue, oldValue) {
                if (newValue === false && newValue != oldValue) {
                    vm.errorsStartUp = allocationFactory.intialPercentagevalidation(
                        $scope.data.beneficiaries,
                        true
                    );
                }
                vm.checkAllocations();
            }
        );
    };

    vm.shouldSubmitButtonBeDisabled = function () {
        var primaryBene = JSON.parse(angular.toJson($scope.data.beneficiaries.Primary));
        var contigentBene = JSON.parse(angular.toJson($scope.data.beneficiaries.Contingent));
        var copyOfbeneficiaries = primaryBene.concat(contigentBene);
        $scope.data.isBeneficiaryDataChanged = _.isEqual(
            copyOfbeneficiaries,
            $scope.data.originalBeneficiaries
        );
        //validate if marital status has changed
        if (
            $scope.data.isBeneficiaryDataChanged &&
            $scope.data.initialMaritalStatus !== $scope.data.maritalStatus
        ) {
            $scope.data.isBeneficiaryDataChanged = false;
        }

        beneficiaryService.setShowSaveDialog(!$scope.data.isBeneficiaryDataChanged);
    };

    vm.openModal = function () {
        // eslint-disable-next-line no-unused-vars
        var modalInstance = $modal.open({
            template: beneficiaryAgreementTemplate,
            controller: "beneficiaryAgreementController as beneCntrl"
        });
    };

    //if thei smethod returns true
    //then we have invalid data on pre-existing bene
    vm.checkValidityofExistingUsers = function (beneficiaries) {
        var hasinvalidData = false;
        var beneKeys = ["Primary", "Contingent"];
        angular.forEach(beneKeys, function (key) {
            angular.forEach(beneficiaries[key], function (beneficiary) {
                var flag = $scope.checkifValidFields(beneficiary);
                if (flag === true) {
                    hasinvalidData = true;
                }
            });
        });
        return hasinvalidData;
    };

    vm.submit = function (valid) {
        vm.loading = true;
        var hasinvalidDataFlag = vm.checkValidityofExistingUsers($scope.data.beneficiaries);
        vm.errosAll = allocationFactory.validateAllocations(
            $scope.data.beneficiaries,
            $scope.data.maritalStatus,
            hasinvalidDataFlag
        );
        vm.errorsPrimary = vm.errosAll[0];
        vm.errorsContigent = vm.errosAll[1];

        if (vm.errorsPrimary.length !== 0 || vm.errorsContigent.length !== 0) {
            vm.loading = false;
        }

        if (valid) {
            // Validate the allocations (list view)
            vm.errosAll = allocationFactory.validateAllocations(
                $scope.data.beneficiaries,
                $scope.data.maritalStatus,
                hasinvalidDataFlag
            );
            vm.errorsPrimary = vm.errosAll[0];
            vm.errorsContigent = vm.errosAll[1];
            // Save the beneficiaries if there are no errors
            if (vm.errorsPrimary.length === 0 && vm.errorsContigent.length === 0) {
                // dont show the save changes modal
                beneficiaryService.setShowSaveDialog(false);

                // Merge the beneficiaries arrays
                var beneficiaries = $scope.data.beneficiaries.Primary.concat(
                    $scope.data.beneficiaries.Contingent
                );
                var copyOfbeneficiaries = JSON.parse(JSON.stringify(beneficiaries));
                angular.forEach(copyOfbeneficiaries, function (beneficiary) {
                    if (beneficiary.newSSN) {
                        beneficiary.socialSecurityNumber = beneficiary.newSSN;
                        delete beneficiary.newSSN;
                    }
                    if (beneficiary.newDOB) {
                        beneficiary.dateOfBirth = beneficiary.newDOB;
                        delete beneficiary.newDOB;
                    }
                });

                dataService.save($scope.data.maritalStatus, copyOfbeneficiaries).then(
                    function success(response) {
                        vm.loading = false;
                        beneficiaryService.setRecords(beneficiaries);
                        participantService.setMaritalStatus(
                            beneficiaryService.getMaritalStatusDescription(
                                $scope.data.maritalStatuses,
                                $scope.data.maritalStatus
                            )
                        );
                        participantService.setConfirmationNumber(response.confirmationNumber);

                        var goToConfirm = vm.extractErrors(response, beneficiaries);
                        if (goToConfirm) {
                            $scope.navigateToConfirmation();
                        } else {
                            $scope.constructUIDetails();
                        }
                    },
                    function error(reason) {
                        vm.loading = false;
                        vm.errosAll.push(reason);
                    }
                );
            }
        } // if (valid)
    }; // vm.submit()

    vm.extractErrors = function (response, beneficiaries) {
        vm.allocationErrorAcrossAllBenes = "";
        vm.errorAcrossAllBenes = [];
        vm.unknownErrors = "";
        var goToConfirm = true;
        var errorDetail;
        var unKnownErrorCodes = "";
        if (response.errors && response.errors.length > 0) {
            goToConfirm = false;
        }
        //Based on the response received from the save call, if there are errors
        //populate different arrays for the different error types
        for (var i = 0; i < response.errors.length; i++) {
            var error = response.errors[i];
            unKnownErrorCodes = unKnownErrorCodes + vm.getUnKnownErrorCodes(error);

            if (error.type === "All") {
                for (var j = 0; j < error.errorDetails.length; j++) {
                    //these are errors that span benes
                    errorDetail = error.errorDetails[j];
                    if (errorDetail.code !== "UNKNOWN") {
                        var found = _.find(vm.beneficiaryBcomErrors.bcomAllAllocationErrorDetails, {
                            code: errorDetail.code
                        });
                        if (found) {
                            if (vm.allocationErrorAcrossAllBenes === "") {
                                vm.allocationErrorAcrossAllBenes = errorDetail.code;
                            }
                        } else {
                            found = _.find(
                                vm.beneficiaryBcomErrors.bcomAllOtherErrorDetails,
                                function (obj) {
                                    return obj === errorDetail.code;
                                }
                            );
                            if (found) {
                                vm.errorAcrossAllBenes.push(
                                    $translate.instant(
                                        "app.beneficiary.bene.bcomAllErrors." + errorDetail.code
                                    )
                                );
                            }
                        }
                    }
                }
            } else if (error.type === "Error") {
                //These are errors returned from failed yellow box validations
                for (var k = 0; k < error.errorDetails.length; k++) {
                    errorDetail = error.errorDetails[k];
                    if (errorDetail.code !== "UNKNOWN") {
                        unKnownErrorCodes = unKnownErrorCodes + " " + errorDetail.code;
                    }
                }
            } else if (error.type === "BENEFICIARY") {
                //These are errors for a specific bene
                var beneficiary = vm.getBeneficiary(error.position, beneficiaries);
                if (beneficiary) {
                    var errors = [];
                    for (var l = 0; l < error.errorDetails.length; l++) {
                        errorDetail = error.errorDetails[l];
                        if (errorDetail.code !== "UNKNOWN") {
                            errors.push(
                                $translate.instant(
                                    "app.beneficiary.bene.bcomBeneErrors." + errorDetail.code
                                )
                            );
                        }
                    }
                    beneficiary.saveErrors = errors;
                }
            }
        }

        if (unKnownErrorCodes !== "") {
            vm.unknownErrors = $translate.instant("app.beneficiary.bene.genericError", {
                errorCodes: unKnownErrorCodes
            });
        }

        return goToConfirm;
    };

    //Identify error codes returned from the save bene call that we do not recognize
    //a custom error message is shown for these unknown errors
    vm.getUnKnownErrorCodes = function (error) {
        var unknownErrorCodes = "";
        var errorDetail;
        for (var j = 0; j < error.errorDetails.length; j++) {
            var found = false;
            errorDetail = error.errorDetails[j];
            if (error.type === "All") {
                found = _.find(vm.beneficiaryBcomErrors.bcomAllAllocationErrorDetails, {
                    code: errorDetail.code
                });
                if (!found) {
                    found = _.find(
                        vm.beneficiaryBcomErrors.bcomAllOtherErrorDetails,
                        function (obj) {
                            return obj === errorDetail.code;
                        }
                    );
                    if (!found) {
                        unknownErrorCodes = unknownErrorCodes + " " + errorDetail.code;
                        errorDetail.code = "UNKNOWN";
                    }
                }
            } else {
                found = _.find(vm.beneficiaryBcomErrors.bcomBeneErrors, function (obj) {
                    return obj === errorDetail.code;
                });
                if (!found) {
                    unknownErrorCodes = unknownErrorCodes + " " + errorDetail.code;
                    //code is changed so it does not get processed again
                    errorDetail.code = "UNKNOWN";
                }
            }
        }
        return unknownErrorCodes;
    };

    vm.getBeneficiary = function (position, beneficiaries) {
        for (var m = 0; m < beneficiaries.length; m++) {
            if (position === m) {
                return beneficiaries[m];
            }
        }
    };

    vm.getTranslatedText = function () {
        var translatedtext = "";
        if (vm.allocationErrorAcrossAllBenes !== "") {
            vm.translate.nonSpousalBeneficiaryFormLink.allocationPercent = _.result(
                _.find(vm.beneficiaryBcomErrors.bcomAllAllocationErrorDetails, {
                    code: vm.allocationErrorAcrossAllBenes
                }),
                "allocationPercent"
            );
            var typeOfMessage = _.result(
                _.find(vm.beneficiaryBcomErrors.bcomAllAllocationErrorDetails, {
                    code: vm.allocationErrorAcrossAllBenes
                }),
                "typeOfMessage"
            );
            if (typeOfMessage === "message") {
                translatedtext = $translate.instant(
                    "app.beneficiary.bene.bcomAllErrors.message",
                    vm.translate.nonSpousalBeneficiaryFormLink
                );
            } else if (typeOfMessage === "messageWithForm") {
                translatedtext = $translate.instant(
                    "app.beneficiary.bene.bcomAllErrors.messageWithForm",
                    vm.translate.nonSpousalBeneficiaryFormLink
                );
            }
        }
        return translatedtext;
    };

    /**
     * simply return true if bene Update access is not enabled
     */
    vm.isViewOnly = function () {
        return beneficiaryService.getBeneAccessParams().beneUAccess === "false";
    };
};

BeneficiaryListController.$inject = [
    "$scope",
    "$modal",
    "beneficiaryService",
    "dataService",
    "participantService",
    "allocationFactory",
    "$state",
    "$stateParams",
    "$translate"
];

export default BeneficiaryListController;
